// extracted by mini-css-extract-plugin
export default {"main_page":"NewsOne_main_page__Njpvc","image":"NewsOne_image__DevvR"};